import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { getThemeColor } from '@/utils/themes'
import { rem } from '@/utils/helpers'
import Typography from '@/components/common/Typography'

const Template = props => {
  const { theme, color, children, ...others } = props
  return (
    <Root theme={theme} _color={color} {...others}>
      <Value variant="d2" component="div" lang="en" color={color}>{children}</Value>
    </Root>
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(64)};
  height: ${rem(64)};
  border: ${rem(4)} solid ${props => getThemeColor(props._color, props.theme)};
  border-radius: 50%;
`

const Value = styled(Typography)``
